import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import axios from 'axios';
import { getIfCurrentBrandNeedsToRecalculatePrice } from '../../../main/selectors';
import { getQuantityValidation } from '../../../bom/selectors';
import { recalculatePriceAsync } from '../../logics';
import { resetPriceRecalculationResponse } from '../../actions';

const PriceRecalculationTrigger = () => {
  const dispatch = useDispatch();

  const needToRecalculatePrice = useSelector(getIfCurrentBrandNeedsToRecalculatePrice);
  const validation = useSelector(getQuantityValidation);

  useEffect(() => {
    const { isValid } = validation;
    if (!isValid || !needToRecalculatePrice) return;

    const cancelTokenSource = axios.CancelToken.source();
    dispatch(recalculatePriceAsync(cancelTokenSource));

    return () => {
      cancelTokenSource.cancel();
      dispatch(resetPriceRecalculationResponse());
    };
  }, [dispatch, needToRecalculatePrice, validation]);

  return <></>;
};

export default PriceRecalculationTrigger;
